import axios from "axios"
import parseObjectToUrlParams from "./utils/parseObjectToUrlParams";
import {isEmpty} from "lodash";

const objectToQueryString = (obj, parentKey = '') => {
  const parts = [];

  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const prefixedKey = parentKey ? `${parentKey}[${key}]` : key;

      if (typeof value === 'object') {
        if(!isEmpty(value)){
          parts.push(objectToQueryString(value, prefixedKey));
        }
      } else {
        parts.push(`${encodeURIComponent(prefixedKey)}=${encodeURIComponent(value)}`);
      }
    }
  }

  return parts.join('&');
}

export default {
  dashboardArticles: () => axios.get('/api/dashboard-articles').then(res => res.data),
  workshopPlansSettings: {
    allFeatures: () => axios.get(`${process.env.REACT_APP_BASE_URI}/workshop-plans-settings/all-features`),
    authorized: () => axios.get('/api/workshop-plans-settings'),
    unauthorized: () => axios.get(`${process.env.REACT_APP_BASE_URI}/workshop-plans-settings`),
  },
  contact: (data) => axios.post(`${process.env.REACT_APP_BASE_URI}/contact`, data),
  welcomeModal: (data) => axios.post('/api/welcome-modal/send', data),
  login: () => axios.get('/api/logged').then(res => res.data),
  registration: (data) => axios.post(`${process.env.REACT_APP_BASE_URI}/registration`, { data }),
  auth: (data) => axios.post('/api/login_check', data).then(res => res.data),
  dataLeaks: () => axios.get('/api/data-leaks'),
  exportData: {
    optima: (dateFrom, dateTo) => `/api/eksport-danych/optima?dataOd=${dateFrom || ''}&dataDo=${dateTo || ''}`,
    epp: (dateFrom, dateTo, type) => `/api/eksport-danych/epp?dataOd=${dateFrom || ''}&dataDo=${dateTo || ''}&type=${type || ''}`,
  },
  googleClientApi: {
    check: () => axios.get('/api/google-client-api/check').then(res => res.data),
    getCalendars: () => axios.get('/api/google-client-api/calendars').then(res => res.data),
  },
  appleIcloud: {
    check: (data) => axios.post('/api/apple-icloud/check', data).then(res => res.data),
    calendar: {
      getCalendars: () => axios.get('/api/apple-icloud/calendar/calendars').then(res => res.data),
    },
  },
  reports: {
    get: (data) => axios.post('/api/reports/get-report', {data}).then(res => res.data),
  },
  gus: {
    find: data => axios.post('/gus/find', data).then(res => res.data),
  },
  user: {
    createWorkshop: () => axios.post('/api/users/workshops'),
    get: () => axios.get('/api/users').then(res => res.data),
    changelogCount: () => axios.get('/api/users/changelog-count').then(res => res.data),
    clearChangelogCount: () => axios.patch('/api/users/clear-changelog-count').then(res => res.data),
    updateTimeActive: (timeActive) => axios.post('/api/users/time-active', { timeActive }).then(res => res.data),
    updateWelcomeModalYouTubeTimer: (timer) => axios.patch('/api/users/welcome-modal-youtube-timer', { timer }),
    updateWelcomeModalYouTubeStart: () => axios.patch('/api/users/welcome-modal-youtube-start'),
    chosenPlan: () => axios.patch('/api/users/chosen-plan'),
    patch: (data) => axios.patch('/api/users', {data}).then(res => res.data),
    getLogged: () => axios.get('/api/users/logged').then(res => res.data),
    acceptRegulations: () => axios.get('/api/users/accept-regulations').then(res => res.data),
    acceptBrowserPluginRegulations: () => axios.get('/api/users/accept-browser-plugin-regulations').then(res => res.data),
  },
  cardControl: {
    option: {
      patch: (optionId, data) => axios.patch('/api/card-controls/options/' + optionId, {data}).then(res => res.data),
    }
  },
  cardControlTemplates: {
    get: (id) => axios.get('/api/card-control-templates/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/card-control-templates/search?sort='+(sort?.sortField || 'cct.id')+'&direction='+(sort?.sortOrder || 'desc'), options).then(res => res.data),
    delete: (cardControlTemplateId) => axios.delete('/api/card-control-templates/' + cardControlTemplateId).then(res => res),
    post: (data) => axios.post('/api/card-control-templates', {data}).then(res => res.data),
    patch: (cardControlId, data) => axios.patch('/api/card-control-templates/' + cardControlId, {data}).then(res => res.data),
  },
  cardControlInUser: {
    get: (id) => axios.get('/api/card-control-in-uses/' + id).then(res => res.data),
  },
  documentSeries: {
    get: (id) => axios.get('/api/document-series/' + id).then(res => res.data),
    search: (options, sort) => axios.post('/api/document-series/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
    patch: (id, data) => axios.patch('/api/document-series/' + id, {data}).then(res => res.data),
  },
  repairOrders: {
    getDateAdmissionNotifyContentPrepared: data => axios.get(`/api/repair-orders/date-admission-notify-content-prepared`, data),
    get: (id) => axios.get('/api/repair-orders/' + id).then(res => res),
    summary: (id) => axios.get('/api/repair-orders/' + id + '/summary').then(res => res.data),
    getFiles: (id) => axios.get('/api/repair-orders/' + id + '/files').then(res => res.data),
    search: (options, sort) => axios.post('/api/repair-orders/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
    delete: (id) => axios.delete('/api/repair-orders/' + id).then(res => res),
    post: (data) => axios.post('/api/repair-orders', {data}).then(res => res.data),
    postFile: (id, data) => axios.post('/api/repair-orders/' + id + '/file', data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data),
    patch: (id, data) => axios.patch('/api/repair-orders/' + id, {data}).then(res => res.data),
    setJobsTimetable: (id, data) => axios.patch('/api/repair-orders/' + id + '/set-jobs-timetable', {data}).then(res => res.data),
    importFromFile: (id, formData) => axios.post(`/api/repair-orders/${id}/import-from-file`, formData).then(res => res.data),
    createFromFile: formData => axios.post('/api/repair-orders/create-from-file', formData),
    updateVehicle: (id, data) => axios.patch(`/api/repair-orders/${id}/vehicle`, {data}).then(res => res.data),
    jobs: {
      findUnasignedStart: (filters) => axios.post('/api/repair-orders/jobs/get-unasigned-start', {filters}).then(res => res.data.jobs),
      search: (options, sort, cancelToken) => axios.post('/api/repair-orders/jobs/search?sort='+(sort?.sortField || 'j.id')+'&direction='+(sort?.sortOrder || 'desc'), options, cancelToken ? {cancelToken: cancelToken.token} : {}).then(res => res.data),
      delete: (jobId, params) => axios.delete(`/api/repair-orders/jobs/${jobId}?${parseObjectToUrlParams(params)}`).then(res => res),
      get: (id) => axios.get('/api/repair-orders/jobs/' + id).then(res => res.data),
      post: (data) => axios.post('/api/repair-orders/jobs', {data}).then(res => res.data),
      postBulk: (data) => axios.post('/api/repair-orders/jobs/bulk', {data}).then(res => res.data),
      patch: (jobId, data) => axios.patch('/api/repair-orders/jobs/' + jobId, {data}).then(res => res.data),
      timeRecords: {
        get: (id) => axios.get('/api/repair-orders/jobs/time-records/' + id).then(res => res),
        search: (options, sort) => axios.post('/api/repair-orders/jobs/time-records/search?sort='+(sort?.sortField || 'tr.id')+'&direction='+(sort?.sortOrder || 'desc'), options).then(res => res.data),
        delete: (jobId) => axios.delete('/api/repair-orders/jobs/time-records/' + jobId).then(res => res),
        post: (data) => axios.post('/api/repair-orders/jobs/time-records', {data}).then(res => res.data),
        patch: (timeRecordId, data) => axios.patch('/api/repair-orders/jobs/time-records/' + timeRecordId, {data}).then(res => res.data),
      },
      inWorkTimes: {
        post: (data) => axios.post('/api/repair-orders/jobs/in-work-times', {data}).then(res => res.data),
        stop: (id) => axios.post('/api/repair-orders/jobs/in-work-times/' + id + '/stop').then(res => res.data),
      },
    },
    parts: {
      search: (options, sort) => axios.post('/api/repair-orders/parts/search?sort='+(sort?.sortField || 'p.id')+'&direction='+(sort?.sortOrder || 'desc'), options).then(res => res.data),
      delete: (partId) => axios.delete('/api/repair-orders/parts/' + partId).then(res => res),
      post: (data) => axios.post('/api/repair-orders/parts', {data}).then(res => res.data),
      postBulk: (data) => axios.post('/api/repair-orders/parts/bulk', {data}).then(res => res.data),
      patch: (partId, data) => axios.patch('/api/repair-orders/parts/' + partId, {data}).then(res => res.data),
    },
    files: {
      delete: (id) => axios.delete('/api/repair-orders/files/' + id).then(res => res),
    },
  },
  repairOrderStatuses: {
    get: (id) => axios.get('/api/repair-order-statuses/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/repair-order-statuses/search?sort='+(sort?.sortField || 's.position')+'&direction='+(sort?.sortOrder || 'asc'), options).then(res => res.data),
    delete: (id) => axios.delete('/api/repair-order-statuses/' + id).then(res => res),
    post: (data) => axios.post('/api/repair-order-statuses', {data}).then(res => res.data),
    patch: (id, data) => axios.patch('/api/repair-order-statuses/' + id, {data}).then(res => res.data),
  },
  clients: {
    get: (id) => axios.get('/api/clients/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/clients/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
    post: (data) => axios.post('/api/clients', {data}).then(res => res.data),
    patch: (id, data) => axios.patch('/api/clients/' + id, {data}).then(res => res.data),
    delete: (id) => axios.delete('/api/clients/' + id).then(res => res),
  },
  saleDocuments: {
    getXml: (id) => axios.get('/api/sale-documents/' + id + '/xml').then(res => res.data),
    patch: (id, data) => axios.patch('/api/sale-documents/' + id, {data}).then(res => res.data),
  },
  vehicles: {
    get: (id) => axios.get('/api/vehicles/' + id).then(res => res.data),
    getFiles: (id) => axios.get('/api/vehicles/' + id + '/files').then(res => res.data),
    post: (data) => axios.post('/api/vehicles', {data}).then(res => res.data),
    postFile: (id, data) => axios.post('/api/vehicles/' + id + '/file', data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data),
    patch: (id, data) => axios.patch('/api/vehicles/' + id, {data}).then(res => res.data),
    delete: (id) => axios.delete('/api/vehicles/' + id).then(res => res),
    files: {
      delete: (id) => axios.delete('/api/vehicles/files/' + id).then(res => res),
    },
  },
  workplaces: {
    get: (id) => axios.get('/api/workplaces/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/workplaces/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
    delete: (id) => axios.delete('/api/workplaces/' + id).then(res => res),
    post: (data) => axios.post('/api/workplaces', {data}).then(res => res.data),
    patch: (id, data) => axios.patch('/api/workplaces/' + id, {data}).then(res => res.data),
  },
  workers: {
    get: (id) => axios.get('/api/workers/' + id).then(res => res),
    loggedInWorkTime: () => axios.get('/api/workers/logged/in-work-time'),
    search: (options, sort) => axios.post('/api/workers/search?sort='+(sort?.sortField || 'w.id')+'&direction='+(sort?.sortOrder || 'desc'), options).then(res => res.data),
    delete: (id) => axios.delete('/api/workers/' + id).then(res => res),
    post: (data) => axios.post('/api/workers', {data}).then(res => res.data),
    patch: (id, data) => axios.patch('/api/workers/' + id, {data}).then(res => res.data),
  },
  workshop: {
    get: () => axios.get('/api/workshops').then(res => res.data),
    deleteFakerData: () => axios.delete('/api/workshops/delete-faker-data').then(res => res),
    patch: (data) => axios.patch('/api/workshops', { data }).then(res => res.data),
    logo: {
      update: (data) => axios.post('/api/workshops/logo', data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data),
      delete: (data) => axios.delete('/api/workshops/logo', data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data),
    },
  },
  calendars: {
    get: (id) => axios.get('/api/calendars/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/calendars/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
    post: (data) => axios.post('/api/calendars', {data}).then(res => res.data),
    patch: (id, data) => axios.patch('/api/calendars/' + id, {data}).then(res => res.data),
    delete: (id) => axios.delete('/api/calendars/' + id).then(res => res),
    events: {
      get: data => axios.post('/api/calendars/events/get', {data}).then(res => res.data),
      post: data => axios.post('/api/calendars/events/add', {data}).then(res => res.data),
      update: data => axios.post('/api/calendars/events/update', {data}).then(res => res.data),
      delete: data => axios.post('/api/calendars/events/delete', {data}).then(res => res.data),
    }
  },
  manufacturers: {
    get: (id) => axios.get('/api/manufacturers/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/manufacturers/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
    post: (data) => axios.post('/api/manufacturers', {data}).then(res => res.data),
    patch: (id, data) => axios.patch('/api/manufacturers/' + id, {data}).then(res => res.data),
    delete: (id) => axios.delete('/api/manufacturers/' + id).then(res => res),
  },
  suppliers: {
    get: (id) => axios.get('/api/suppliers/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/suppliers/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
    post: (data) => axios.post('/api/suppliers', data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data),
    createStage1: (data) => axios.post('/api/suppliers/stage1', data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data),
    edit: (id, data) => axios.post('/api/suppliers/edit/' + id, data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data),
    delete: (id) => axios.delete('/api/suppliers/' + id).then(res => res),
    documentSynchro: (supplierId, data) => axios.post(`/api/suppliers/${supplierId}/document-synchronize`, data).then(res => res.data),
  },
  repairOrderKinds: {
    get: (id) => axios.get('/api/repair-order-kinds/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/repair-order-kinds/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
    post: (data) => axios.post('/api/repair-order-kinds', {data}).then(res => res.data),
    patch: (id, data) => axios.patch('/api/repair-order-kinds/' + id, {data}).then(res => res.data),
    delete: (id) => axios.delete('/api/repair-order-kinds/' + id).then(res => res),
  },
  jobTemplates: {
    get: (id) => axios.get('/api/job-templates/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/job-templates/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
  },
  workshopProductPriceGroups: {
    get: (id) => axios.get('/api/workshop-product-price-groups/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/workshop-product-price-groups/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
    post: (data) => axios.post('/api/workshop-product-price-groups', {data}).then(res => res.data),
    patch: (id, data) => axios.patch('/api/workshop-product-price-groups/' + id, {data}).then(res => res.data),
    delete: (id) => axios.delete('/api/workshop-product-price-groups/' + id).then(res => res),
  },
  vats: {
    get: (id) => axios.get('/api/vats/' + id).then(res => res),
    search: (options, sort) => axios.post('/api/vats/search?sort='+sort.sortField+'&direction='+sort.sortOrder, options).then(res => res.data),
  },
  products: {
    getFiles: (id) => axios.get('/api/products/' + id + '/files').then(res => res.data),
    postFile: (id, data) => axios.post('/api/products/' + id + '/file', data, { headers: { 'content-type': 'multipart/form-data' } }).then(res => res.data),
    files: {
      delete: (id) => axios.delete('/api/products/files/' + id).then(res => res),
    },
    get: (id) => axios.get('/api/products/' + id).then(res => res),
    delete: (id) => axios.delete('/api/products/' + id).then(res => res),
    post: (data, warehouseDocumentCreate) => axios.post('/api/products', {data, warehouseDocumentCreate}).then(res => res.data),
    patch: (id, data) => axios.patch('/api/products/' + id, {data}).then(res => res.data),
  },
  warehouse: {
    products: {
      get: (id) => axios.get('/api/warehouse/products/' + id).then(res => res),
    },
    documents: {
      r: {
        changeStatus: (data) => axios.post('/api/warehouse/documents/r/change-status', data).then(res => res),
      },
      patchBulk: (ids, data) => axios.patch('/api/warehouse/documents/bulk', {ids, data}).then(res => res.data),
    },
    incomeFromWholesale: formData => axios.post('/api/warehouse/income-from-wholesale', formData).then(res => res.data),
  },
  timetable: {
    events: {
      get: (data) => axios.post('/api/timetable/get-events', data).then(res => res.data),
    },
  },
  import: {
    products: formData => axios.post('/api/import/products', formData).then(res => res.data),
    jobTemplates: formData => axios.post('/api/import/job-templates', formData).then(res => res.data),
    vehicles: formData => axios.post('/api/import/vehicles', formData).then(res => res.data),
    clients: formData => axios.post('/api/import/clients', formData).then(res => res.data),
    dataImport: formData => axios.post('/api/import/data-import', formData).then(res => res.data),
  },
  workshopPlanTransaction: {
    getInvoicePdf: (id) => `/api/workshop-plan-transactions/${id}/invoice`,
  },

  tecRmi: {
    print: params => `/api/tec-rmi/print.pdf?${objectToQueryString({ params })}`,
    findByVin: (params = {}) => axios.get('/api/tec-rmi/find-by-vin?' + objectToQueryString({ params })),
    adjust: {
      componentSubgroupHtml: (params = {}) => axios.post('/api/tec-rmi/webShop30/adjust/componentSubgroupHtml?' + objectToQueryString({ params })),
      list: (params = {}) => axios.get('/api/tec-rmi/adjust/list?' + objectToQueryString({ params })),
      itemMpData: (params = {}) => axios.get('/api/tec-rmi/adjust/itemMpData?' + objectToQueryString({ params })),
      mainGroupData: (params = {}) => axios.get('/api/tec-rmi/adjust/mainGroupData?' + objectToQueryString({ params })),
    },
    common: {
      componentTopicTree: (params = {}) => axios.get('/api/tec-rmi/webShop30/common/componentTopicTree?' + objectToQueryString({ params })),
    },
    graphics: {
      genArtManualList: (params = {}) => axios.post('/api/tec-rmi/graphics/genArtManualList', { params }),
      bodiesForGraphics: (params = {}) => axios.get('/api/tec-rmi/graphics/bodiesForGraphics?' + objectToQueryString({ params })),
      subGroupQuals: (params = {}) => axios.get('/api/tec-rmi/graphics/subGroupQuals?' + objectToQueryString({ params })),
      linkedAdjustmentData: (params = {}) => axios.get('/api/tec-rmi/graphics/linkedAdjustmentData?' + objectToQueryString({ params })),
      linkedTechnicalManuals: (params = {}) => axios.get('/api/tec-rmi/graphics/linkedTechnicalManuals?' + objectToQueryString({ params })),
      linkedWorkPositions: (params = {}) => axios.get('/api/tec-rmi/graphics/linkedWorkPositions?' + objectToQueryString({ params })),
      maingroupHtml: (params = {}) => axios.get('/api/tec-rmi/graphics/maingroupHtml?' + objectToQueryString({ params })),
      subgroupHtml: (params = {}) => axios.get('/api/tec-rmi/graphics/subgroupHtml?' + objectToQueryString({ params })),
      vehicleHtml: (params = {}) => axios.get('/api/tec-rmi/graphics/vehicleHtml?' + objectToQueryString({ params })),
    },
    maintenance: {
      bodiesForMaintenance: (params = {}) => axios.get('/api/tec-rmi/maintenance/bodiesForMaintenance?' + objectToQueryString({ params })),
      maintenancePlanData: (params = {}) => axios.post('/api/tec-rmi/maintenance/maintenancePlanData?' + objectToQueryString({ params })),
      possibleCooGroupFilterParameters: (params = {}) => axios.post('/api/tec-rmi/maintenance/possibleCooGroupFilterParameters?' + objectToQueryString({ params })),
      possibleGearboxCodes: (params = {}) => axios.post('/api/tec-rmi/maintenance/possibleGearboxCodes?' + objectToQueryString({ params })),
      serviceProposal: (params = {}) => axios.post('/api/tec-rmi/maintenance/serviceProposal?' + objectToQueryString({ params })),
      serviceProposalCooGroups: (params = {}) => axios.post('/api/tec-rmi/maintenance/serviceProposalCooGroups?' + objectToQueryString({ params })),
      works: (params = {}) => axios.get('/api/tec-rmi/maintenance/works?' + objectToQueryString({ params })),
    },
    comfortWiring: {
      componentList: (params = {}) => axios.post('/api/tec-rmi/webShop30/comfortWiring/componentList', { params }),
      list: (params = {}) => axios.get('/api/tec-rmi/comfortWiring/manualList?' + objectToQueryString({ params })),
      manualHtml: (params = {}) => axios.get('/api/tec-rmi/comfortWiring/manualHtml?' + objectToQueryString({ params })),
      manualHtmlPrint: 'comfortWiring/manualHtml',
    },
    diagnostics: {
      componentSubgroupHtml: (params = {}) => axios.post('/api/tec-rmi/webShop30/diagnostics/componentSubgroupHtml?' + objectToQueryString({ params })),
      componentsForType: (params = {}) => axios.get('/api/tec-rmi/diagnostics/componentsForType?' + objectToQueryString({ params })),
      errorCode: (params = {}) => axios.get('/api/tec-rmi/diagnostics/errorCode?' + objectToQueryString({ params })),
      list: (params = {}) => axios.get('/api/tec-rmi/diagnostics/list?' + objectToQueryString({ params })),
      manualHtml: (params = {}) => axios.get('/api/tec-rmi/diagnostics/manualHtml?' + objectToQueryString({ params })),
      manualHtmlPrint: 'diagnostics/manualHtml',
    },
    relaysFuses: {
      boxConfigurations: (params = {}) => axios.get('/api/tec-rmi/relaysFuses/boxConfigurations?' + objectToQueryString({ params })),
      boxDetailHtml: (params = {}) => axios.get('/api/tec-rmi/relaysFuses/boxDetailHtml?' + objectToQueryString({ params })),
      boxDetailHtmlPrint: 'relaysFuses/boxDetailHtml',
      boxOverviewHtml: (params = {}) => axios.get('/api/tec-rmi/relaysFuses/boxOverviewHtml?' + objectToQueryString({ params })),
      componentsForType: (params = {}) => axios.get('/api/tec-rmi/relaysFuses/componentsForType?' + objectToQueryString({ params })),
      componentList: (params = {}) => axios.post('/api/tec-rmi/webShop30/relaysFuses/componentList', { params }),
      linkedWiringDiagrams: (params = {}) => axios.get('/api/tec-rmi/relaysFuses/linkedWiringDiagrams?' + objectToQueryString({ params })),
      linkedDiagnostics: (params = {}) => axios.get('/api/tec-rmi/relaysFuses/linkedDiagnostics?' + objectToQueryString({ params })),
    },
    manuals: {
      componentList: (params = {}) => axios.post('/api/tec-rmi/webShop30/manuals/componentList', { params }),
      errorCodeSearchHtml: (params = {}) => axios.get('/api/tec-rmi/manuals/errorCodeSearchHtml?' + objectToQueryString({ params })),
      errorCodeSearchHtmlPrint: 'manuals/errorCodeSearchHtml',
      list: (params = {}) => axios.get('/api/tec-rmi/manuals/manualList?' + objectToQueryString({ params })),
      manualHtml: (params = {}) => axios.get('/api/tec-rmi/manuals/manualHtml?' + objectToQueryString({ params })),
      manualHtmlPrint: 'manuals/manualHtml',
      linkedTechnicalManuals: (params = {}) => axios.get('/api/tec-rmi/manuals/linkedTechnicalManuals?' + objectToQueryString({ params })),
    },
    prices: {
      partsForWork: (params = {}) => axios.post('/api/tec-rmi/prices/partsForWorks?' + objectToQueryString({ params })),
    },
    paint: {
      workList: (params = {}) => axios.get('/api/tec-rmi/paint/workList?' + objectToQueryString({ params })),
    },
    sos: {
      componentList: (params = {}) => axios.post('/api/tec-rmi/webShop30/bulletins/componentList', { params }),
      list: (params = {}) => axios.get('/api/tec-rmi/bulletins/manualList?' + objectToQueryString({ params })),
      manualHtml: (params = {}) => axios.get('/api/tec-rmi/bulletins/manualHtml?' + objectToQueryString({ params })),
      manualHtmlPrint: 'bulletins/manualHtml',
    },
    times: {
      bodiesForTimes: (params = {}) => axios.get('/api/tec-rmi/times/bodiesForTimes?' + objectToQueryString({ params })),
      componentList: (params = {}) => axios.post('/api/tec-rmi/webShop30/times/componentList', { params }),
      workList: (params = {}) => axios.get('/api/tec-rmi/times/workList?' + objectToQueryString({ params })),
      workSteps: (params = {}) => axios.get('/api/tec-rmi/times/workSteps?' + objectToQueryString({ params })),
      workStepsMulti: (params = {}) => axios.get('/api/tec-rmi/times/workStepsMulti?' + objectToQueryString({ params })),
      workStepsForSubgroup: (params = {}) => axios.get('/api/tec-rmi/times/workStepsForSubgroup?' + objectToQueryString({ params })),
      rawTools: (params = {}) => axios.get('/api/tec-rmi/times/rawTools?' + objectToQueryString({ params })),
    },
    wiring: {
      componentList: (params = {}) => axios.post('/api/tec-rmi/webShop30/wiring/componentList', { params }),
      list: (params = {}) => axios.get('/api/tec-rmi/wiring/manualList?' + objectToQueryString({ params })),
      manualHtml: (params = {}) => axios.get('/api/tec-rmi/wiring/manualHtml?' + objectToQueryString({ params })),
      manualHtmlPrint: 'wiring/manualHtml',
      linkedDiagnostics: (params = {}) => axios.get('/api/tec-rmi/wiring/linkedDiagnostics?' + objectToQueryString({ params })),
      linkedWiringDiagrams: (params = {}) => axios.get('/api/tec-rmi/wiring/linkedWiringDiagrams?' + objectToQueryString({ params })),
      linkedFuseRelais: (params = {}) => axios.get('/api/tec-rmi/wiring/linkedFuseRelais?' + objectToQueryString({ params })),
    },
    vehicleTree: {
      availableModules: (params = {}) => axios.get('/api/tec-rmi/vehicleTree/availableModules?' + objectToQueryString({ params })),
      makeList: (params = {}) => axios.post('/api/tec-rmi/vehicleTree/makeList', { params }),
      rangeList: (params = {}) => axios.post('/api/tec-rmi/vehicleTree/rangeList', { params }),
      typeList: (params = {}) => axios.post('/api/tec-rmi/vehicleTree/typeList', { params }),
      typeDetails: (params = {}) => axios.post('/api/tec-rmi/vehicleTree/typeDetails', { params }),
    },
    tyres: {
      allTyresForType: (params = {}) => axios.get('/api/tec-rmi/tyres/allTyresForType?' + objectToQueryString({ params })),
    },
    notes: {
      allInfosForType: (params = {}) => axios.get('/api/tec-rmi/notes/allInfosForType?' + objectToQueryString({ params })),
    },
  },
};
